import { useEffect, useRef, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { MaterialIcon } from "@/components/MaterialIcon";
import { useAuth } from "@/context/AuthContext";
import { useApi } from "@/lib/useApi";

const Item = ({ children, to, href, onClick, testId }) => {
  const cls = "block w-full text-left px-3.5 py-2 rounded-full text-[17px] font-semibold hover:bg-[#EDEDEB] transition-colors duration-150";
  if (to) return <Link to={to} className={cls} onClick={onClick} data-testid={testId}>{children}</Link>;
  return (
    <a href={href || "#"} target={href ? "_blank" : undefined} rel="noreferrer" className={cls} onClick={onClick} data-testid={testId}>
      {children}
    </a>
  );
};

export const AvatarMenu = () => {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);
  const { user, logout } = useAuth();
  const { data: settings } = useApi("/settings");
  const navigate = useNavigate();

  useEffect(() => {
    if (!open) return;
    const onDoc = (e) => ref.current && !ref.current.contains(e.target) && setOpen(false);
    document.addEventListener("mousedown", onDoc);
    return () => document.removeEventListener("mousedown", onDoc);
  }, [open]);

  return (
    <div className="relative" ref={ref}>
      <button
        type="button"
        onClick={() => setOpen((o) => !o)}
        className={`flex items-center justify-center transition-[transform,color] duration-200 hover:scale-110 ${open ? "text-black" : "text-[#9AA0A6] hover:text-black"}`}
        aria-label="Account"
        data-testid="avatar-button"
      >
        <MaterialIcon name="account_circle" size={36} weight={500} />
      </button>
      {open && (
        <div
          className="absolute right-0 top-[calc(100%+28px)] w-[230px] bg-white rounded-2xl shadow-[0_10px_40px_rgba(0,0,0,0.14)] p-3 df-panel-in z-50"
          data-testid="avatar-menu"
        >
          <Item to="/organizer" onClick={() => setOpen(false)} testId="menu-publish-event">
            Publish your event
          </Item>
          <Item href={settings?.suggest_feature_url} onClick={() => setOpen(false)} testId="menu-suggest-feature">
            Suggest a feature
          </Item>
          {user && (
            <>
              <Item to="/admin" onClick={() => setOpen(false)} testId="menu-admin-settings">
                {user.role === "admin" ? "Admin Settings" : "Organizer Dashboard"}
              </Item>
              <button
                type="button"
                className="block w-full text-left px-3.5 py-2 rounded-full text-[15px] font-medium text-[#8A8A8A] hover:bg-[#EDEDEB] transition-colors"
                onClick={async () => {
                  setOpen(false);
                  await logout();
                  navigate("/");
                }}
                data-testid="menu-logout"
              >
                Log out
              </button>
            </>
          )}
        </div>
      )}
    </div>
  );
};
